module.exports = __webpack_public_path__ + "img/method-women-left.35e735e9.png";